import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Config, ConfigRepository, Loading } from "../domain";
import { ServiceLocater, Services } from "../service-locater";
import { AppThunk } from "./store";

type ConfigState = {
  loading: Loading;
  editLoading: Loading;
  config?: Config;
};

const initialState: ConfigState = {
  loading: "idle",
  editLoading: "idle",
};

const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    configLoading(state) {
      state.loading = "pending";
    },
    configFailed(state) {
      state.loading = "failed";
    },
    configLoaded(state, { payload }: PayloadAction<Config>) {
      state.config = payload;
      state.loading = "succeeded";
    },

    configEditLoading(state) {
      state.editLoading = "pending";
    },
    configEditFailed(state) {
      state.editLoading = "failed";
    },
    configEditSuccess(state) {
      state.editLoading = "succeeded";
    },
    resetConfigEdit(state) {
      state.editLoading = "idle";
    },
  },
});

export default configSlice.reducer;

const {
  configLoading,
  configFailed,
  configLoaded,
  configEditLoading,
  configEditFailed,
  configEditSuccess,
  resetConfigEdit,
} = configSlice.actions;

export const loadConfig = (): AppThunk => async (dispatch) => {
  dispatch(configLoading());
  const res = await ServiceLocater.get<ConfigRepository>(
    Services.ConfigRepository
  ).get();
  res.fold(
    (_) => {
      dispatch(configFailed());
    },
    (r) => {
      dispatch(configLoaded(r));
    }
  );
};

export const editConfig = (
  deliveryPrice: number,
  freeDeliveryMinPrice: number,
  pageSize: number
): AppThunk => async (dispatch) => {
  dispatch(configEditLoading());
  const res = await ServiceLocater.get<ConfigRepository>(
    Services.ConfigRepository
  ).edit({ deliveryPrice, freeDeliveryMinPrice, pageSize });
  res.fold(
    (_) => dispatch(configEditFailed()),
    (_) => dispatch(configEditSuccess())
  );
  dispatch(resetConfigEdit());
};
